var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ellipsis-button',{ref:"popover",attrs:{"placement":"right","heading":"Schedule settings","show-options":['slot', 'delete']},on:{"delete":function($event){return _vm.onDelete()}}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }